module.exports = __webpack_public_path__ + "static/media/gum.cef7154e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/gum.svg
// module id = 958
// module chunks = 0